module.exports = __webpack_public_path__ + "img/shop-details.20a75260.png";